{
	"ContentGrid": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center gap-2 sm:gap-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "bg-linear-to-br from-base-300 via-transparent to-base-300 m-2 sm:m-4 p-2 sm:p-4 w-80"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center"
				},
				"imageClass": {
					"translations": {},
					"value": "h-48 object-contain mx-auto rounded"
				},
				"previewHeightClass": {
					"translations": {},
					"value": "h-24"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "articles"
		},
		"index": 0
	},
	"Features Article": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "Features Article Aside"
				},
				"containerClass": {
					"translations": {},
					"value": "col-span-1 h-full md:sticky md:top-0 md:max-h-[1500px] md:overflow-y-scroll md:scroll-smooth"
				},
				"notes": {
					"translations": {},
					"value": "md:max-h is going to fit content in the sidebar and still make is stick to the top.  the problem is you gotta do it for all articles where toc varies"
				}
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "MarkedContent Article"
				},
				"containerClass": {
					"translations": {},
					"value": "col-span-1 md:col-span-2 md:pb-[100vh] bg-base-300 p-2 sm:p-4 rounded-xl"
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "m-2 sm:m-4"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 gap-2 md:grid-cols-3 md:gap-4"
				},
				"otherClasses": {
					"translations": {},
					"value": "col-span-1 h-full md:sticky md:top-0 md:max-h-[1500px] md:overflow-y-scroll md:scroll-smooth md:pb-[100vh]"
				}
			}
		},
		"index": 1,
		"pageOrder": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		}
	},
	"Features Article Aside": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "TOC Article"
				},
				"containerClass": {
					"translations": {},
					"value": "w-full bg-base-300 p-2 sm:p-4 rounded-xl"
				}
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "Form Contact News"
				},
				"containerClass": {
					"translations": {},
					"value": "w-full bg-base-300 p-2 sm:p-4 rounded-xl"
				}
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "RelatedArticles Article"
				},
				"containerClass": {
					"translations": {},
					"value": "w-full"
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "my-0 py-0"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 gap-2 sm:gap-4"
				},
				"otherClasses": {
					"translations": {},
					"value": "w-full"
				}
			}
		},
		"index": 2
	},
	"Features Article Grid": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center gap-2 sm:gap-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "bg-linear-to-br from-base-300 via-transparent to-base-300 m-2 sm:m-4 p-2 sm:p-4 w-80"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "flex flex-wrap justify-center"
				},
				"imageClass": {
					"translations": {},
					"value": "h-48 object-contain mx-auto rounded"
				},
				"previewHeightClass": {
					"translations": {},
					"value": "h-24"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "articles"
		},
		"index": 3,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		}
	},
	"Form Contact News": {
		"Question 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"ar": "1",
						"en": "1",
						"en-GB": "1",
						"en-US": "1",
						"es": "1",
						"es-419": "1",
						"es-ES": "1",
						"he": "1",
						"it": "1",
						"pl": "1",
						"sw": "1",
						"tl": "1",
						"vi": "1",
						"zh": "1"
					},
					"value": "2"
				},
				"heading": {
					"translations": {
						"ar": "الاسم الأول",
						"en": "First Name",
						"en-GB": "First Name",
						"en-US": "First Name",
						"es": "Nombre de pila",
						"es-419": "Nombre de pila",
						"es-ES": "Nombre de pila",
						"he": "שֵׁם פְּרַטִי",
						"it": "Nome di battesimo",
						"pl": "Imię",
						"sw": "Jina la Kwanza",
						"tl": "Pangalan",
						"vi": "Tên",
						"zh": "名"
					},
					"value": "First Name"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {
						"ar": "الرجاء إدخال اسمك",
						"en": "Please enter your Name",
						"en-GB": "Please enter your Name",
						"en-US": "Please enter your Name",
						"es": "Por favor ingrese su nombre",
						"es-419": "Por favor ingrese su nombre",
						"es-ES": "Por favor ingrese su nombre",
						"he": "אנא הזן את שמך",
						"it": "Inserisci il tuo nome",
						"pl": "Proszę podać swoje imię",
						"sw": "Tafadhali ingiza Jina lako",
						"tl": "Pakilagay ang iyong Pangalan",
						"vi": "Vui lòng nhập tên của bạn",
						"zh": "请输入您的姓名"
					},
					"value": "Please enter your Name"
				},
				"label": {
					"translations": {
						"ar": "الاسم الأول",
						"en": "First Name",
						"en-GB": "First Name",
						"en-US": "First Name",
						"es": "Nombre de pila",
						"es-419": "Nombre de pila",
						"es-ES": "Nombre de pila",
						"he": "שֵׁם פְּרַטִי",
						"it": "Nome di battesimo",
						"pl": "Imię",
						"sw": "Jina la Kwanza",
						"tl": "Pangalan",
						"vi": "Tên",
						"zh": "名"
					},
					"value": "First Name"
				},
				"required": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"ar": "نص",
						"en": "text",
						"en-GB": "text",
						"en-US": "text",
						"es": "texto",
						"es-419": "texto",
						"es-ES": "texto",
						"he": "טֶקסט",
						"it": "testo",
						"pl": "tekst",
						"sw": "maandishi",
						"tl": "teksto",
						"vi": "chữ",
						"zh": "文本"
					},
					"value": "text"
				}
			}
		},
		"Question 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"ar": "2",
						"en": "2",
						"en-GB": "2",
						"en-US": "2",
						"es": "2",
						"es-419": "2",
						"es-ES": "2",
						"he": "2",
						"it": "2",
						"pl": "2",
						"sw": "2",
						"tl": "2",
						"vi": "2",
						"zh": "2"
					},
					"value": "2"
				},
				"heading": {
					"translations": {
						"ar": "اسم العائلة",
						"en": "Last Name",
						"en-GB": "Last Name",
						"en-US": "Last Name",
						"es": "Apellido",
						"es-419": "Apellido",
						"es-ES": "Apellido",
						"he": "שֵׁם מִשׁפָּחָה",
						"it": "Cognome",
						"pl": "Nazwisko",
						"sw": "Jina la Ukoo",
						"tl": "Apelyido",
						"vi": "Họ",
						"zh": "姓"
					},
					"value": "Last Name"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {
						"ar": "الرجاء إدخال اسم عائلتك",
						"en": "Please enter you last name",
						"en-GB": "Please enter you last name",
						"en-US": "Please enter you last name",
						"es": "Por favor, introduzca su apellido",
						"es-419": "Por favor, introduzca su apellido",
						"es-ES": "Por favor, introduzca su apellido",
						"he": "אנא הזן את שם המשפחה שלך",
						"it": "Inserisci il tuo cognome",
						"pl": "Proszę podać swoje nazwisko",
						"sw": "Tafadhali ingiza jina lako la ukoo",
						"tl": "Pakilagay ang iyong apelyido",
						"vi": "Vui lòng nhập họ của bạn",
						"zh": "请输入您的姓氏"
					},
					"value": "Please enter you last name"
				},
				"label": {
					"translations": {
						"ar": "اسم العائلة",
						"en": "Last Name",
						"en-GB": "Last Name",
						"en-US": "Last Name",
						"es": "Apellido",
						"es-419": "Apellido",
						"es-ES": "Apellido",
						"he": "שֵׁם מִשׁפָּחָה",
						"it": "Cognome",
						"pl": "Nazwisko",
						"sw": "Jina la Ukoo",
						"tl": "Apelyido",
						"vi": "Họ",
						"zh": "姓"
					},
					"value": "Last Name"
				},
				"required": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"ar": "نص",
						"en": "text",
						"en-GB": "text",
						"en-US": "text",
						"es": "texto",
						"es-419": "texto",
						"es-ES": "texto",
						"he": "טֶקסט",
						"it": "testo",
						"pl": "tekst",
						"sw": "maandishi",
						"tl": "teksto",
						"vi": "chữ",
						"zh": "文本"
					},
					"value": "text"
				}
			}
		},
		"Question 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {
						"ar": "عنوان البريد الإلكتروني",
						"en": "Email Address",
						"en-GB": "Email Address",
						"en-US": "Email Address",
						"es": "Dirección de correo electrónico",
						"es-419": "Dirección de correo electrónico",
						"es-ES": "Dirección de correo electrónico",
						"he": "כתובת דוא\"ל",
						"it": "Indirizzo e-mail",
						"pl": "Adres e-mail",
						"sw": "Anwani ya Barua Pepe",
						"tl": "Email Address",
						"vi": "Địa chỉ email",
						"zh": "电子邮件"
					},
					"value": "Email Address"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {
						"ar": "يرجى إدخال عنوان بريد إلكتروني صالح",
						"en": "Please enter a valid email address",
						"en-GB": "Please enter a valid email address",
						"en-US": "Please enter a valid email address",
						"es": "Por favor, introduce una dirección de correo electrónico válida",
						"es-419": "Por favor, introduce una dirección de correo electrónico válida",
						"es-ES": "Por favor, introduce una dirección de correo electrónico válida",
						"he": "אנא הזן כתובת דוא\"ל תקפה",
						"it": "Si prega di inserire un indirizzo email valido",
						"pl": "Proszę podać prawidłowy adres e-mail",
						"sw": "Tafadhali weka anwani halali ya barua pepe",
						"tl": "Mangyaring maglagay ng wastong email address",
						"vi": "Vui lòng nhập địa chỉ email hợp lệ.",
						"zh": "请输入有效的电子邮件地址"
					},
					"value": "Please enter a valid email address"
				},
				"label": {
					"translations": {
						"ar": "عنوان البريد الإلكتروني",
						"en": "Email Address",
						"en-GB": "Email Address",
						"en-US": "Email Address",
						"es": "Dirección de correo electrónico",
						"es-419": "Dirección de correo electrónico",
						"es-ES": "Dirección de correo electrónico",
						"he": "כתובת דוא\"ל",
						"it": "Indirizzo e-mail",
						"pl": "Adres e-mail",
						"sw": "Anwani ya Barua Pepe",
						"tl": "Email Address",
						"vi": "Địa chỉ email",
						"zh": "电子邮件"
					},
					"value": "Email Address"
				},
				"required": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"ar": "بريد إلكتروني",
						"en": "email",
						"en-GB": "email",
						"en-US": "email",
						"es": "correo electrónico",
						"es-419": "correo electrónico",
						"es-ES": "correo electrónico",
						"he": "אֶלֶקטרוֹנִי",
						"it": "e-mail",
						"pl": "e-mail",
						"sw": "barua pepe",
						"tl": "email",
						"vi": "e-mail",
						"zh": "电子邮件"
					},
					"value": "email"
				}
			}
		},
		"Question 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {
						"ar": "رقم التليفون",
						"en": "Phone Number",
						"en-GB": "Phone Number",
						"en-US": "Phone Number",
						"es": "Número de teléfono",
						"es-419": "Número de teléfono",
						"es-ES": "Número de teléfono",
						"he": "מספר טלפון",
						"it": "Numero di telefono",
						"pl": "Numer telefonu",
						"sw": "Nambari ya Simu",
						"tl": "Numero ng Telepono",
						"vi": "Số điện thoại",
						"zh": "电话号码"
					},
					"value": "Phone Number"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {
						"ar": "الرجاء إدخال رقم هاتف صحيح",
						"en": "Please Enter a valid phone number",
						"en-GB": "Please Enter a valid phone number",
						"en-US": "Please Enter a valid phone number",
						"es": "Por favor, introduzca un número de teléfono válido",
						"es-419": "Por favor, introduzca un número de teléfono válido",
						"es-ES": "Por favor, introduzca un número de teléfono válido",
						"he": "אנא הזן מספר טלפון תקין",
						"it": "Inserisci un numero di telefono valido",
						"pl": "Proszę podać prawidłowy numer telefonu",
						"sw": "Tafadhali Ingiza nambari halali ya simu",
						"tl": "Mangyaring maglagay ng wastong numero ng telepono",
						"vi": "Vui lòng nhập số điện thoại hợp lệ.",
						"zh": "请输入有效的电话号码"
					},
					"value": "Please Enter a valid phone number"
				},
				"label": {
					"translations": {
						"ar": "رقم التليفون",
						"en": "Phone Number",
						"en-GB": "Phone Number",
						"en-US": "Phone Number",
						"es": "Número de teléfono",
						"es-419": "Número de teléfono",
						"es-ES": "Número de teléfono",
						"he": "מספר טלפון",
						"it": "Numero di telefono",
						"pl": "Numer telefonu",
						"sw": "Nambari ya Simu",
						"tl": "Numero ng Telepono",
						"vi": "Số điện thoại",
						"zh": "电话号码"
					},
					"value": "Phone Number"
				},
				"type": {
					"translations": {
						"ar": "هاتف",
						"en": "tel",
						"en-GB": "tel",
						"en-US": "tel",
						"es": "teléfono",
						"es-419": "teléfono",
						"es-ES": "teléfono",
						"he": "טלפון",
						"it": "telefono",
						"pl": "telefon",
						"sw": "simu",
						"tl": "telepono",
						"vi": "điện thoại",
						"zh": "电话"
					},
					"value": "tel"
				}
			}
		},
		"Question 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"ar": "2",
						"en": "2",
						"en-GB": "2",
						"en-US": "2",
						"es": "2",
						"es-419": "2",
						"es-ES": "2",
						"he": "2",
						"it": "2",
						"pl": "2",
						"sw": "2",
						"tl": "2",
						"vi": "2",
						"zh": "2"
					},
					"value": "2"
				},
				"heading": {
					"translations": {
						"ar": "رسالتك (اختياري)",
						"en": "Your message (optional)",
						"en-GB": "Your message (optional)",
						"en-US": "Your message (optional)",
						"es": "Tu mensaje (opcional)",
						"es-419": "Tu mensaje (opcional)",
						"es-ES": "Tu mensaje (opcional)",
						"he": "ההודעה שלך (אופציונלי)",
						"it": "Il tuo messaggio (facoltativo)",
						"pl": "Twoja wiadomość (opcjonalnie)",
						"sw": "Ujumbe wako (si lazima)",
						"tl": "Ang iyong mensahe (opsyonal)",
						"vi": "Lời nhắn của bạn (tùy chọn)",
						"zh": "您的留言（可选）"
					},
					"value": "Your message (optional)"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"label": {
					"translations": {
						"ar": "رسالة",
						"en": "Message",
						"en-GB": "Message",
						"en-US": "Message",
						"es": "Mensaje",
						"es-419": "Mensaje",
						"es-ES": "Mensaje",
						"he": "הוֹדָעָה",
						"it": "Messaggio",
						"pl": "Wiadomość",
						"sw": "Ujumbe",
						"tl": "Mensahe",
						"vi": "Tin nhắn",
						"zh": "信息"
					},
					"value": "Message"
				},
				"type": {
					"translations": {
						"ar": "منطقة نصية",
						"en": "textarea",
						"en-GB": "textarea",
						"en-US": "textarea",
						"es": "área de texto",
						"es-419": "área de texto",
						"es-ES": "área de texto",
						"he": "אזור טקסט",
						"it": "area di testo",
						"pl": "obszar tekstowy",
						"sw": "eneo la maandishi",
						"tl": "lugar ng teksto",
						"vi": "vùng văn bản",
						"zh": "文本区域"
					},
					"value": "textarea"
				}
			}
		},
		"Question 06": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"ar": "2",
						"en": "2",
						"en-GB": "2",
						"en-US": "2",
						"es": "2",
						"es-419": "2",
						"es-ES": "2",
						"he": "2",
						"it": "2",
						"pl": "2",
						"sw": "2",
						"tl": "2",
						"vi": "2",
						"zh": "2"
					},
					"value": "2"
				},
				"heading": {
					"translations": {
						"ar": "أوافق على تلقي الرسائل النصية من مكتب المحامية آمبر بيلانتي",
						"en": "I agree to accept text messages from The Law Offices of Amber Bellante",
						"en-GB": "I agree to accept text messages from The Law Offices of Amber Bellante",
						"en-US": "I agree to accept text messages from The Law Offices of Amber Bellante",
						"es": "Acepto recibir mensajes de texto de The Law Offices of Amber Bellante",
						"es-419": "Acepto recibir mensajes de texto de The Law Offices of Amber Bellante",
						"es-ES": "Acepto recibir mensajes de texto de The Law Offices of Amber Bellante",
						"he": "אני מסכים/ה לקבל הודעות טקסט ממשרד עורכי הדין של אמבר בלנטה",
						"it": "Accetto di ricevere messaggi di testo da The Law Offices of Amber Bellante",
						"pl": "Zgadzam się na otrzymywanie wiadomości tekstowych od Kancelarii Adwokackiej Amber Bellante",
						"sw": "Nakubali kupokea ujumbe mfupi kutoka Ofisi za Sheria za Amber Bellante",
						"tl": "Sumasang-ayon akong tumanggap ng mga text message mula sa The Law Offices of Amber Bellante",
						"vi": "Tôi đồng ý nhận tin nhắn văn bản từ Văn phòng Luật sư Amber Bellante.",
						"zh": "我同意接收来自 Amber Bellante 律师事务所的短信。"
					},
					"value": "I agree to accept text messages from The Law Offices of Amber Bellante"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {
						"ar": "يجب عليك الموافقة على تلقي الرسائل النصية",
						"en": "You must consent to agree to receive text messages",
						"en-GB": "You must consent to agree to receive text messages",
						"en-US": "You must consent to agree to receive text messages",
						"es": "Debes dar tu consentimiento para aceptar recibir mensajes de texto.",
						"es-419": "Debes dar tu consentimiento para aceptar recibir mensajes de texto.",
						"es-ES": "Debes dar tu consentimiento para aceptar recibir mensajes de texto.",
						"he": "עליך להסכים לקבל הודעות טקסט",
						"it": "Devi acconsentire per accettare di ricevere messaggi di testo",
						"pl": "Aby wyrazić zgodę na otrzymywanie wiadomości tekstowych, musisz wyrazić zgodę",
						"sw": "Lazima ukubali kupokea ujumbe mfupi",
						"tl": "Dapat kang sumang-ayon na makatanggap ng mga text message",
						"vi": "Bạn phải đồng ý nhận tin nhắn văn bản.",
						"zh": "您必须同意接收短信"
					},
					"value": "You must consent to agree to receive text messages"
				},
				"label": {
					"translations": {
						"ar": "موافقة",
						"en": "Consent",
						"en-GB": "Consent",
						"en-US": "Consent",
						"es": "Consentir",
						"es-419": "Consentir",
						"es-ES": "Consentir",
						"he": "הַסכָּמָה",
						"it": "Consenso",
						"pl": "Zgoda",
						"sw": "Idhini",
						"tl": "Pahintulot",
						"vi": "Bằng lòng",
						"zh": "同意"
					},
					"value": "Consent"
				},
				"optionLabelPos": {
					"translations": {
						"ar": "يمين",
						"en": "right",
						"en-GB": "right",
						"en-US": "right",
						"es": "bien",
						"es-419": "bien",
						"es-ES": "bien",
						"he": "יָמִינָה",
						"it": "Giusto",
						"pl": "Prawidłowy",
						"sw": "kulia",
						"tl": "kanan",
						"vi": "Phải",
						"zh": "正确的"
					},
					"value": "right"
				},
				"options": {
					"translations": {
						"ar": "أنا موافق",
						"en": "I agree",
						"en-GB": "I agree",
						"en-US": "I agree",
						"es": "Estoy de acuerdo",
						"es-419": "Estoy de acuerdo",
						"es-ES": "Estoy de acuerdo",
						"he": "אני מסכים",
						"it": "Sono d'accordo",
						"pl": "Zgadzam się",
						"sw": "Nakubali",
						"tl": "Sumasang-ayon ako",
						"vi": "Tôi đồng ý",
						"zh": "我同意"
					},
					"value": "I agree"
				},
				"required": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"requiredCount": {
					"translations": {
						"ar": "1",
						"en": "1",
						"en-GB": "1",
						"en-US": "1",
						"es": "1",
						"es-419": "1",
						"es-ES": "1",
						"he": "1",
						"it": "1",
						"pl": "1",
						"sw": "1",
						"tl": "1",
						"vi": "1",
						"zh": "1"
					},
					"value": "1"
				},
				"type": {
					"translations": {
						"ar": "مربع الاختيار",
						"en": "checkbox",
						"en-GB": "checkbox",
						"en-US": "checkbox",
						"es": "caja",
						"es-419": "caja",
						"es-ES": "caja",
						"he": "תיבת הסימון",
						"it": "casella di controllo",
						"pl": "pole wyboru",
						"sw": "kisanduku cha kuteua",
						"tl": "checkbox",
						"vi": "hộp kiểm",
						"zh": "复选框"
					},
					"value": "checkbox"
				}
			}
		},
		"Section 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "معلومات الاتصال",
						"en": "Contact Information",
						"en-GB": "Contact Information",
						"en-US": "Contact Information",
						"es": "Información del contacto",
						"es-419": "Información del contacto",
						"es-ES": "Información del contacto",
						"he": "פרטי קשר",
						"it": "Informazioni sui contatti",
						"pl": "Informacje kontaktowe",
						"sw": "Taarifa za Mawasiliano",
						"tl": "Impormasyon sa Pakikipag-ugnayan",
						"vi": "Thông tin liên hệ",
						"zh": "联系信息"
					},
					"value": "Contact Information"
				},
				"questions": {
					"translations": {
						"ar": "السؤال 1+||+السؤال 2+||+السؤال 3+||+السؤال 4+||+السؤال 5",
						"en": "Question 01+||+Question 02+||+Question 03+||+Question 04+||+Question 05",
						"en-GB": "Question 01+||+Question 02+||+Question 03+||+Question 04+||+Question 05",
						"en-US": "Question 01+||+Question 02+||+Question 03+||+Question 04+||+Question 05",
						"es": "Pregunta 01+||+Pregunta 02+||+Pregunta 03+||+Pregunta 04+||+Pregunta 05",
						"es-419": "Pregunta 01+||+Pregunta 02+||+Pregunta 03+||+Pregunta 04+||+Pregunta 05",
						"es-ES": "Pregunta 01+||+Pregunta 02+||+Pregunta 03+||+Pregunta 04+||+Pregunta 05",
						"he": "שאלה 01+||+שאלה 02+||+שאלה 03+||+שאלה 04+||+שאלה 05",
						"it": "Domanda 01+||+Domanda 02+||+Domanda 03+||+Domanda 04+||+Domanda 05",
						"pl": "Pytanie 01+||+Pytanie 02+||+Pytanie 03+||+Pytanie 04+||+Pytanie 05",
						"sw": "Swali la 01+||+Swali la 02+||+Swali la 03+||+Swali la 04+||+Swali la 05",
						"tl": "Tanong 01+||+Tanong 02+||+Tanong 03+||+Tanong 04+||+Tanong 05",
						"vi": "Câu hỏi 01+||+Câu hỏi 02+||+Câu hỏi 03+||+Câu hỏi 04+||+Câu hỏi 05",
						"zh": "问题 01+||+问题 02+||+问题 03+||+问题 04+||+问题 05"
					},
					"value": "Question 01+||+Question 02+||+Question 03+||+Question 04+||+Question 05+||+Question 06"
				},
				"type": {
					"translations": {
						"ar": "قسم",
						"en": "section",
						"en-GB": "section",
						"en-US": "section",
						"es": "sección",
						"es-419": "sección",
						"es-ES": "sección",
						"he": "סָעִיף",
						"it": "sezione",
						"pl": "sekcja",
						"sw": "sehemu",
						"tl": "seksyon",
						"vi": "phần",
						"zh": "部分"
					},
					"value": "section"
				}
			}
		},
		"general": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"confirmationMessage": {
					"translations": {
						"ar": "### شكرًا لتواصلك!\n\n\n<br />\n\nتم إرسال رسالتك بنجاح.\n\nسنتواصل معك قريبًا.\n\n<br />\n\n*هل تستخدم جهاز كمبيوتر عامًا؟ انقر على \"إعادة تعيين\" لمسح بياناتك.*",
						"en": "### Thank you for reaching out!\n\n<br />\n\nYour message has been submitted successfully.  \nWe will be in touch shortly.\n\n<br />\n\n*Using a public computer? Click reset to clear your information.*",
						"en-GB": "### Thank you for reaching out!\n\n<br />\n\nYour message has been submitted successfully.  \nWe will be in touch shortly.\n\n<br />\n\n*Using a public computer? Click reset to clear your information.*",
						"en-US": "### Thank you for reaching out!\n\n<br />\n\nYour message has been submitted successfully.  \nWe will be in touch shortly.\n\n<br />\n\n*Using a public computer? Click reset to clear your information.*",
						"es": "### ¡Gracias por contactarnos!\n\n<br />\n\nSu mensaje se ha enviado correctamente.\n\nNos pondremos en contacto con usted en breve.\n\n<br />\n\n*¿Usa una computadora pública? Haga clic en \"Restablecer\" para borrar su información.*",
						"es-419": "### ¡Gracias por contactarnos!\n\n<br />\n\nSu mensaje se ha enviado correctamente.\n\nNos pondremos en contacto con usted en breve.\n\n<br />\n\n*¿Usa una computadora pública? Haga clic en \"Restablecer\" para borrar su información.*",
						"es-ES": "### ¡Gracias por contactarnos!\n\n<br />\n\nSu mensaje se ha enviado correctamente.\n\nNos pondremos en contacto con usted en breve.\n\n<br />\n\n*¿Usa una computadora pública? Haga clic en \"Restablecer\" para borrar su información.*",
						"he": "### תודה שפנית אליך!\n\n<br />\n\nהודעתך נשלחה בהצלחה. \nניצור איתך קשר בקרוב.\n\n<br />\n\n*משתמש במחשב ציבורי? לחץ על איפוס כדי לנקות את המידע שלך.*",
						"it": "### Grazie per averci contattato!\n\n<br />\n\nIl tuo messaggio è stato inviato correttamente.\nTi contatteremo a breve.\n\n<br />\n\n*Utilizzi un computer pubblico? Fai clic su \"Reimposta\" per cancellare le tue informazioni.*",
						"pl": "### Dziękujemy za kontakt!\n\n<br />\n\nTwoja wiadomość została pomyślnie wysłana.\nWkrótce się z Tobą skontaktujemy.\n\n<br />\n\n*Korzystasz z komputera publicznego? Kliknij „Resetuj”, aby wyczyścić swoje dane.*",
						"sw": "### Asante kwa kuwasiliana nawe!\n\n<br />\n\nUjumbe wako umewasilishwa kwa mafanikio. \nTutawasiliana nawe hivi karibuni.\n\n<br />\n\n*Unatumia kompyuta ya umma? Bonyeza \"reset\" ili kufuta taarifa zako.*",
						"tl": "### Salamat sa pakikipag-ugnayan!\n\n<br />\n\nMatagumpay na naisumite ang iyong mensahe. \nMakikipag-ugnayan kami sa iyo sa lalong madaling panahon.\n\n<br />\n\n*Gumagamit ng pampublikong computer? I-click ang reset para i-clear ang iyong impormasyon.*",
						"vi": "Cảm ơn bạn đã liên hệ!\n\n<br />\n\nTin nhắn của bạn đã được gửi thành công.\n\nChúng tôi sẽ liên hệ lại với bạn trong thời gian ngắn.\n\n<br />\n\n*Bạn đang sử dụng máy tính công cộng? Hãy nhấp vào \"Đặt lại\" để xóa thông tin của bạn.*",
						"zh": "### 感谢您的联系！\n\n<br />\n\n您的留言已成功提交。\n\n我们将尽快与您联系。\n\n<br />\n\n*如果您使用的是公共电脑，请点击“重置”按钮清除您的信息。*"
					},
					"value": "### Thank you for reaching out!\n\n<br />\n\nYour message has been submitted successfully.  \nWe will be in touch shortly.\n\n<br />\n\n*Using a public computer? Click reset to clear your information.*"
				},
				"formName": {
					"translations": {
						"ar": "اتصال",
						"en": "Contact",
						"en-GB": "Contact",
						"en-US": "Contact",
						"es": "Contacto",
						"es-419": "Contacto",
						"es-ES": "Contacto",
						"he": "מַגָע",
						"it": "Contatto",
						"pl": "Kontakt",
						"sw": "Mawasiliano",
						"tl": "Makipag-ugnayan",
						"vi": "Liên hệ",
						"zh": "接触"
					},
					"value": "Contact"
				}
			}
		},
		"index": 4
	},
	"Head": {
		"index": 5,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "01"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "الأخبار والتحديثات",
				"en": "News & Updates",
				"en-GB": "News & Updates",
				"en-US": "News & Updates",
				"es": "Noticias y actualizaciones",
				"es-419": "Noticias y actualizaciones",
				"es-ES": "Noticias y actualizaciones",
				"he": "חדשות ועדכונים",
				"it": "Notizie e aggiornamenti",
				"pl": "Aktualności i aktualizacje",
				"sw": "Habari na Masasisho",
				"tl": "Balita at Mga Update",
				"vi": "Tin tức & Cập nhật",
				"zh": "新闻与动态"
			},
			"type": "TextInput",
			"value": "News & Updates"
		}
	},
	"Head Article": {
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "articles"
		},
		"index": 6,
		"pageOrder": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "01"
		}
	},
	"MarkedContent Article": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"containerClass": {
					"translations": {},
					"value": "w-full"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "articles"
		},
		"index": 7
	},
	"PageBanner": {
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "جسر البرج الذهبي ونهر سكرامنتو في سكرامنتو، كاليفورنيا، تم تصويرهما من منتزه ريفر ووك ليلاً مع وجود النجوم في السماء.",
						"en": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"en-GB": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"en-US": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"es": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"es-419": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"es-ES": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"he": "גשר מגדל הזהב ונהר סקרמנטו בסקרמנטו, קליפורניה, צולם מפארק ריבר ווק בלילה עם כוכבים בשמיים.",
						"it": "Il Gold Tower Bridge e il fiume Sacramento a Sacramento, California, fotografati dal River Walk Park di notte con le stelle nel cielo.",
						"pl": "Most Gold Tower Bridge i rzeka Sacramento w Sacramento w Kalifornii, sfotografowane nocą z River Walk Park na tle rozgwieżdżonego nieba.",
						"sw": "Daraja la Mnara wa Dhahabu na Mto Sacramento huko Sacramento, California, vilipigwa picha kutoka Hifadhi ya Mto Walk usiku na nyota angani.",
						"tl": "Ang Gold Tower Bridge at ang Sacramento River sa Sacramento, California, na kinunan ng litrato mula sa River Walk Park sa gabi kasama ang mga bituin sa kalangitan.",
						"vi": "Cầu Tháp Vàng và sông Sacramento ở Sacramento, California, được chụp từ công viên River Walk vào ban đêm với bầu trời đầy sao.",
						"zh": "加利福尼亚州萨克拉门托市的金塔桥和萨克拉门托河，照片拍摄于夜晚的河滨公园，天空繁星点点。"
					},
					"value": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fnews%2FPageBanner%2FbgImage%2Fshutterstock_2243996415-cropped.jpg?alt=media&token=3eb88831-c11f-47fa-b9d0-3b94a57b64ac",
				"formattedSize": "567.15 KB",
				"height": 500,
				"name": "shutterstock_2243996415-cropped.jpg",
				"path": "uploads/news/PageBanner/bgImage/shutterstock_2243996415-cropped.jpg",
				"query": "?as=run",
				"size": 580764,
				"type": "image/jpeg",
				"updated": "2026-02-06T15:56:56.577Z",
				"width": 1600
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "opacity-20 grayscale"
				}
			}
		},
		"index": 8,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {
				"ar": "مكتب المحامية آمبر بيلانتي",
				"en": "The Law Offices of Amber Bellante",
				"en-GB": "The Law Offices of Amber Bellante",
				"en-US": "The Law Offices of Amber Bellante",
				"es": "El bufete de abogados de Amber Bellante",
				"es-419": "El bufete de abogados de Amber Bellante",
				"es-ES": "El bufete de abogados de Amber Bellante",
				"he": "משרד עורכי הדין של אמבר בלנטה",
				"it": "Lo studio legale di Amber Bellante",
				"pl": "Kancelaria Adwokacka Amber Bellante",
				"sw": "Ofisi za Sheria za Amber Bellante",
				"tl": "Ang Mga Tanggapan ng Abogado ni Amber Bellante",
				"vi": "Văn phòng luật sư Amber Bellante",
				"zh": "安珀·贝兰特律师事务所"
			},
			"type": "TextInput",
			"value": "The Law Offices of Amber Bellante"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "الأخبار والتحديثات",
				"en": "News & Updates",
				"en-GB": "News & Updates",
				"en-US": "News & Updates",
				"es": "Noticias y actualizaciones",
				"es-419": "Noticias y actualizaciones",
				"es-ES": "Noticias y actualizaciones",
				"he": "חדשות ועדכונים",
				"it": "Notizie e aggiornamenti",
				"pl": "Aktualności i aktualizacje",
				"sw": "Habari na Masasisho",
				"tl": "Balita at Mga Update",
				"vi": "Tin tức & Cập nhật",
				"zh": "新闻与动态"
			},
			"type": "TextInput",
			"value": "News & Updates"
		},
		"useMask": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	},
	"PageBanner Article": {
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "جسر البرج الذهبي ونهر سكرامنتو في سكرامنتو، كاليفورنيا، تم تصويرهما من منتزه ريفر ووك ليلاً مع وجود النجوم في السماء.",
						"en": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"en-GB": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"en-US": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky.",
						"es": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"es-419": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"es-ES": "El Puente de la Torre de Oro y el río Sacramento en Sacramento, California, fotografiados desde el River Walk Park de noche con estrellas en el cielo.",
						"he": "גשר מגדל הזהב ונהר סקרמנטו בסקרמנטו, קליפורניה, צולם מפארק ריבר ווק בלילה עם כוכבים בשמיים.",
						"it": "Il Gold Tower Bridge e il fiume Sacramento a Sacramento, California, fotografati dal River Walk Park di notte con le stelle nel cielo.",
						"pl": "Most Gold Tower Bridge i rzeka Sacramento w Sacramento w Kalifornii, sfotografowane nocą z River Walk Park na tle rozgwieżdżonego nieba.",
						"sw": "Daraja la Mnara wa Dhahabu na Mto Sacramento huko Sacramento, California, vilipigwa picha kutoka Hifadhi ya Mto Walk usiku na nyota angani.",
						"tl": "Ang Gold Tower Bridge at ang Sacramento River sa Sacramento, California, na kinunan ng litrato mula sa River Walk Park sa gabi kasama ang mga bituin sa kalangitan.",
						"vi": "Cầu Tháp Vàng và sông Sacramento ở Sacramento, California, được chụp từ công viên River Walk vào ban đêm với bầu trời đầy sao.",
						"zh": "加利福尼亚州萨克拉门托市的金塔桥和萨克拉门托河，照片拍摄于夜晚的河滨公园，天空繁星点点。"
					},
					"value": "Gold Tower Bridge and Sacramento River in Sacramento, California, photographed from River Walk Park at night with stars in the sky."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fnews%2FPageBanner%20Article%2FbgImage%2Fshutterstock_2243996415-cropped.jpg?alt=media&token=1a2ea0be-323f-4618-a043-354f00f752c0",
				"formattedSize": "567.15 KB",
				"height": 500,
				"name": "shutterstock_2243996415-cropped.jpg",
				"path": "uploads/news/PageBanner Article/bgImage/shutterstock_2243996415-cropped.jpg",
				"query": "?as=run",
				"size": 580764,
				"type": "image/jpeg",
				"updated": "2026-02-09T01:54:04.132Z",
				"width": 1600
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "w-full opacity-20 grayscale"
				},
				"subtitleClass": {
					"translations": {},
					"value": "pt-4 sm:pt-8"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "articles"
		},
		"index": 9,
		"pageOrder": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "News & Updates"
		},
		"useMask": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	},
	"RelatedArticles Article": {
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "articles"
		},
		"index": 10,
		"relatedArticleCategoryLabel": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "News & Updates"
		}
	},
	"TOC Article": {
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "articles"
		},
		"index": 11
	}
}